import { supabase } from "@/integrations/supabase/client";
import { trackFormSubmit, trackWhatsAppClick } from "@/lib/analytics";

interface FormSubmission {
  nom: string;
  telephone: string;
  email?: string;
  service?: string;
  message?: string;
  source: string;
}

export const submitFormAndRedirectToWhatsApp = async (data: FormSubmission) => {
  // Save to database
  await supabase.from("form_submissions").insert({
    nom: data.nom.trim().slice(0, 100),
    telephone: data.telephone.trim().slice(0, 20),
    email: data.email?.trim().slice(0, 255) || null,
    service: data.service || null,
    message: data.message?.trim().slice(0, 1000) || null,
    source: data.source,
  });

  // Track conversion events
  trackFormSubmit(data.source);
  trackWhatsAppClick(data.source);

  // Build WhatsApp message
  const lines = [
    `📋 *Nouvelle demande de devis*`,
    `👤 Nom : ${data.nom.trim()}`,
    `📞 Tél : ${data.telephone.trim()}`,
  ];
  if (data.email) lines.push(`📧 Email : ${data.email.trim()}`);
  if (data.service) lines.push(`🔧 Service : ${data.service}`);
  if (data.message) lines.push(`💬 Message : ${data.message.trim()}`);
  lines.push(`📍 Source : ${data.source}`);

  const text = encodeURIComponent(lines.join("\n"));
  const waUrl = `https://wa.me/33632864661?text=${text}`;

  window.open(waUrl, "_blank");
};
